import { yupResolver } from "@hookform/resolvers/yup";
import { CircularProgress, TextField, Typography } from "@mui/material";
import { grey, red } from "@mui/material/colors";
import { Box } from "@mui/system";
import React, { useState } from "react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import {
  Link,
  Navigate,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { GlobalContainer } from "../../common/components/Container";
import { Link as RouterLink } from "react-router-dom";
import * as yup from "yup";
import { StyledButton } from "../../common/components/Button";
import { resetPassword } from "../../api/authApi";
import { PasswordInput } from "../../common/components/Input";

const ResetPassword = () => {
  const [isSubmitting, setSubmitting] = useState(false);
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();
  const {
    register,
    formState: { errors },
    handleSubmit,
    setError,
  } = useForm({
    resolver: yupResolver(
      yup.object().shape({
        password: yup
          .string("Enter a valid password")
          .min(8, "Password must be 8 characters or longer")
          .matches(
            /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[^\w\d]).*$/,
            "Password must have 1 number, 1 uppercase letter, 1 lowercase letter, and 1 special character"
          )
          .required("New password is required"),
        repeatPassword: yup
          .string("Enter a valid password")
          .oneOf([yup.ref("password"), null], "Passwords don't match")
          .required("Repeat password is required"),
      })
    ),
  });

  useEffect(() => {
    if (!token) {
      navigate("/");
    }

    // check if token is valid
  }, [navigate, token]);

  const handleChangePassword = async (values) => {
    const tokenWithReplacedSpaceToPlus = token.replace(/ /g, "+");
    try {
      setSubmitting(true);
      const response = await resetPassword({
        token: tokenWithReplacedSpaceToPlus,
        password: values.password,
      });
      setSubmitting(false);
      console.log(response);
      navigate("/");
    } catch (err) {
      setSubmitting(false);
      setError("submission", {
        type: "custom",
        message: err.response.data.message,
      });
    }
  };

  return (
    <Box sx={{ width: "100vw", height: "100vh", backgroundColor: grey[200] }}>
      <GlobalContainer theme="purple">
        <Box
          maxWidth="sm"
          sx={{
            width: "100%",
            margin: "0 auto",
            paddingX: 8,
          }}
        >
          <Box
            sx={{
              marginTop: 4,
              backgroundColor: "white",
              borderRadius: "15px",
              boxShadow:
                "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
            }}
          >
            <Box sx={{ padding: 2.5 }}>
              <form onSubmit={handleSubmit(handleChangePassword)}>
                <Typography
                  component="h1"
                  sx={{
                    fontSize: "1.25rem",
                    fontWeight: 600,
                    color: grey[800],
                  }}
                >
                  Reset your password
                </Typography>
                <Typography
                  sx={{ marginTop: 1, fontSize: "0.875rem", color: grey[700] }}
                >
                  Choose a strong password with 1 uppercase, 1 lowercase, 1
                  number, and 1 special character.
                </Typography>
                <PasswordInput
                  fullWidth
                  type="password"
                  placeholder="Password"
                  sx={{ marginTop: 2 }}
                  error={Boolean(errors.password)}
                  helperText={errors.password?.message}
                  register={register("password")}
                />
                <PasswordInput
                  fullWidth
                  type="password"
                  placeholder="Re-enter password"
                  sx={{ marginTop: 1 }}
                  error={Boolean(errors.repeatPassword)}
                  helperText={errors.repeatPassword?.message}
                  register={register("repeatPassword")}
                />
                <Typography
                  sx={{
                    fontSize: "0.875rem",
                    color: red[400],
                    marginTop: 1,
                  }}
                >
                  {errors.submission?.message}
                </Typography>
                <Box sx={{ marginTop: 2, textAlign: "right" }}>
                  <Box sx={{ display: "inline-block" }}>
                    {isSubmitting && <CircularProgress />}
                    {!isSubmitting && (
                      <>
                        <Link
                          component={RouterLink}
                          sx={{ textDecoration: "none" }}
                          to="/"
                        >
                          <StyledButton theme="purple">Cancel</StyledButton>
                        </Link>
                        <StyledButton
                          theme="green"
                          type="submit"
                          sx={{ marginLeft: 1 }}
                        >
                          Submit
                        </StyledButton>
                      </>
                    )}
                  </Box>
                </Box>
              </form>
            </Box>
          </Box>
        </Box>
      </GlobalContainer>
    </Box>
  );
};

export default ResetPassword;
